module.exports = __webpack_public_path__ + "img/facebook.d03235bf.png";